module.exports = __webpack_public_path__ + "img/logo2.b894d431.png";